import ActionButton from "Components/atoms/buttons/action-button";
import DemoDataButton from "Components/molecule/demo-data-button";
import React, { ReactNode, useEffect } from "react";
import { Link } from "react-router-dom";
import { Row, Col, BreadcrumbItem } from "reactstrap";


interface BreadcrumbProps {
  breadcrumbItem: string | ReactNode,
  title: string,
  actions?: ReactNode
  showItem?: boolean
}

const Breadcrumb = ({ breadcrumbItem, title, actions, showItem = true }: BreadcrumbProps) => {
  // Every page shows its own name in the browser tab
  useEffect(() => {
    const name = typeof breadcrumbItem === 'string' ? breadcrumbItem : title
    if (name) document.title = `${name} | IbexIQ`
  }, [breadcrumbItem, title])

  return (
    <Row>
      <Col className="col-12">
        <div className="breadcrumb-container">
          <div className="breadcrumb-left">
            <h4 className="breadcrumb-heading">{breadcrumbItem}</h4>
            {actions}
          </div>
          <div className="breadcrumb-right">
            <DemoDataButton />
            <ol className="breadcrumb breadcrumb-nav">
              <BreadcrumbItem>
                <Link to="#">{title}</Link>
              </BreadcrumbItem>
              {showItem && <BreadcrumbItem active>{breadcrumbItem}</BreadcrumbItem>}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Breadcrumb;
